import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { TratamientoExternoSchema } from "../data/TratamientoExternoSchema";
import Grid from "./layout/Grid";
import Panel from "./layout/Panel";
import Row from "./layout/Row";
import Col from "./layout/Col";
import Label from "./controls/Label";
import TextField from "./controls/TextField";
import { isInvalid } from "../utils/forms";
import AmmountField from "./controls/AmmountField";
import QuestionField from "./controls/QuestionField";
import TextareaField from "./controls/TextareaField";
import ObjectField from "./controls/ObjectField";
import SelectField from "./controls/SelectField";
import Pagination from "./controls/Pagination";
import Button from "./controls/Button";
import { PersonaJuridicaSchema } from "../data/PersonaJuridicaSchema";
import { useDialog } from "./controls/Dialog";
import Alert from "./controls/Alert";
import { TipoTramite } from "../utils/enums";

export function TratamientoExternoForm({
  value,
  page,
  pages,
  select,
  append,
  replace,
  remove,
  tramiteForm,
  unidadCaudalAnual,
  frecuenciasRetiro,
  disabled,
}) {
  const { t } = useTranslation();
  const dialog = useDialog({ showing: false, variant: "warning" });
  const handleConPeligrosidadChange = (form) => (event) => {
    if (event.target.checked) {
      form.setFieldValue("tratador", null);
      form.setFieldTouched("tratador", true, false);
      form.setFieldValue("transportista", null);
      form.setFieldTouched("transportista", true, false);
      form.setFieldValue("frecuenciaRetiros", null);
      form.setFieldTouched("frecuenciaRetiros", true, false);
    } else {
      form.setFieldValue(
        "tratador",
        PersonaJuridicaSchema.cast(undefined, { assert: false }),
        true,
      );
      form.setFieldTouched("tratador", false, false);
      form.setFieldValue(
        "transportista",
        PersonaJuridicaSchema.cast(undefined, { assert: false }),
        true,
      );
      form.setFieldTouched("transportista", false, false);
      form.setFieldValue("frecuenciaRetiros", null);
      form.setFieldTouched("frecuenciaRetiros", false, false);
    }
    form.handleChange(event);
  };
  const handleDenominacionChange = (form) => (event) => {
    form.handleChange(event);
  };
  const handleCaudalAnualChange = (form) => (event) => {
    form.handleChange(event);
  };
  const handleDescripcionChange = (form) => (event) => {
    form.handleChange(event);
  };
  const handleTransportistaChange = (form) => (event) => {
    form.handleChange(event);
  };
  const handleTratadorChange = (form) => (event) => {
    form.handleChange(event);
  };
  const handleFrecuencaRetirosChange = (form) => (event) => {
    form.handleChange(event);
  };
  const handleSubmit = (values) => {
    if (
      values.conPeligrosidad &&
      !tramiteForm.values.conResiduosPeligrosos &&
      tramiteForm.values.tipo?.codigo === TipoTramite.DJG
    ) {
      dialog.display(
        t("tratamientoExternoForm.conPeligrosidad.dialog.title"),
        <p>{t("tratamientoExternoForm.conPeligrosidad.dialog.message")}</p>,
        t("tratamientoExternoForm.conPeligrosidad.dialog.accept"),
        t("tratamientoExternoForm.conPeligrosidad.dialog.decline"),
        (event) => {
          if (page === -1) {
            append(values);
          } else {
            replace(values, page);
          }
          dialog.close();
        },
        (event) => {
          dialog.close();
        },
      );
    } else {
      if (page === -1) {
        append(values);
      } else {
        replace(values, page);
      }
    }
  };
  return (
    <>
      {dialog.component}
      <Formik
        initialValues={value}
        enableReinitialize={true}
        validateOnChange={true}
        validationSchema={TratamientoExternoSchema}
        onSubmit={handleSubmit}
      >
        {(form) => (
          <Grid as={<Panel />} className="formulario embebido">
            <Row>
              <Col>
                <Label>{t("tratamientoExternoForm.titulo")}</Label>
              </Col>
            </Row>
            <Row>
              <Col>
                <TextField
                  id="tratamientoExterno_denominacion"
                  name="denominacion"
                  label={t("tratamientoExterno.denominacion")}
                  value={form.values?.denominacion}
                  onChange={handleDenominacionChange(form)}
                  isInvalid={isInvalid("denominacion", form)}
                  error={t(form.errors.denominacion)}
                  disabled={disabled}
                />
              </Col>
            </Row>
            <Row>
              <Col lg={4}>
                <AmmountField
                  id="tratamientoExterno_caudalAnual"
                  name="caudalAnual"
                  label={t("tratamientoExterno.caudalAnual")}
                  value={form.values?.caudalAnual}
                  onChange={handleCaudalAnualChange(form)}
                  unit={unidadCaudalAnual}
                  isInvalid={isInvalid("caudalAnual", form)}
                  error={t(form.errors.caudalAnual)}
                  disabled={disabled}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <QuestionField
                  id="tratamientoExterno_conPeligrosidad"
                  name="conPeligrosidad"
                  label={t("tratamientoExterno.conPeligrosidad")}
                  value={form.values?.conPeligrosidad}
                  onChange={handleConPeligrosidadChange(form)}
                  error={t(form.errors.conPeligrosidad)}
                  disabled={disabled}
                />
              </Col>
            </Row>
            {form.values?.conPeligrosidad &&
              tramiteForm.values.tipo?.codigo === TipoTramite.DJG && (
                <Row>
                  <Col>
                    <Alert variant="warning">
                      <p className="text-muted" style={{ fontSize: "10px" }}>
                        {t("tratamientoExternoForm.conPeligrosidad.message")}
                      </p>
                    </Alert>
                  </Col>
                </Row>
              )}
            <Row>
              <Col>
                <TextareaField
                  id="tratamientoExterno_descripcion"
                  name="descripcion"
                  label={t("tratamientoExterno.descripcion")}
                  value={form.values?.descripcion}
                  onChange={handleDescripcionChange(form)}
                  rows={12}
                  isInvalid={isInvalid("descripcion", form)}
                  error={t(form.errors.descripcion)}
                  disabled={disabled}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <label>{t("tratamientoExterno.transportista")}</label>
                <ObjectField
                  id="tratamientoExterno_transportista"
                  name="transportista"
                  value={form.values?.transportista}
                  onChange={handleTransportistaChange(form)}
                  disabled={disabled || form.values?.conPeligrosidad}
                >
                  {({ value, setProperty, disabled }) => (
                    <Grid>
                      <Row>
                        <Col lg={4}>
                          <TextField
                            id="tratamientoExterno_transportista_CUIT"
                            name="transportista.CUIT"
                            label={t("personaJuridica.CUIT")}
                            value={value?.CUIT}
                            onChange={(event) => {
                              event.preventDefault();
                              setProperty("CUIT", event.target.value);
                            }}
                            isInvalid={isInvalid("transportista.CUIT", form)}
                            error={t(form.errors.transportista?.CUIT)}
                            disabled={disabled}
                          />
                        </Col>
                        <Col lg={8}>
                          <TextField
                            id="tratamientoExterno_transportista_razonSocial"
                            name="transportista.razonSocial"
                            label={t("personaJuridica.razonSocial")}
                            value={value?.razonSocial}
                            onChange={(event) => {
                              event.preventDefault();
                              setProperty("razonSocial", event.target.value);
                            }}
                            isInvalid={isInvalid(
                              "transportista.razonSocial",
                              form,
                            )}
                            error={t(form.errors.transportista?.razonSocial)}
                            disabled={disabled}
                          />
                        </Col>
                      </Row>
                    </Grid>
                  )}
                </ObjectField>
              </Col>
            </Row>
            <Row>
              <Col lg={4}>
                <SelectField
                  id="tratamientoExterno_frecuenciaRetiros"
                  name="frecuenciaRetiros"
                  label={t("tratamientoExterno.frecuenciaRetiros")}
                  value={form.values?.frecuenciaRetiros}
                  onChange={handleFrecuencaRetirosChange(form)}
                  options={frecuenciasRetiro}
                  labelAttr="codigo"
                  valueAttr="nombre"
                  emptyLabel="..."
                  isInvalid={isInvalid("frecuenciaRetiros", form)}
                  error={t(form.errors.frecuenciaRetiros)}
                  disabled={disabled || form.values?.conPeligrosidad}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <label>{t("tratamientoExterno.tratador")}</label>
                <ObjectField
                  id="tratamientoExterno_tratador"
                  name="tratador"
                  value={form.values?.tratador}
                  onChange={handleTratadorChange(form)}
                  disabled={disabled || form.values?.conPeligrosidad}
                >
                  {({ value, setProperty, disabled }) => (
                    <Grid>
                      <Row>
                        <Col lg={4}>
                          <TextField
                            id="tratamientoExterno_tratador_CUIT"
                            name="tratador.CUIT"
                            label={t("personaJuridica.CUIT")}
                            value={value?.CUIT}
                            onChange={(event) => {
                              event.preventDefault();
                              setProperty("CUIT", event.target.value);
                            }}
                            isInvalid={isInvalid("tratador.CUIT", form)}
                            error={t(form.errors.tratador?.CUIT)}
                            disabled={disabled}
                          />
                        </Col>
                        <Col lg={8}>
                          <TextField
                            id="tratamientoExterno_tratador_razonSocial"
                            name="tratador.razonSocial"
                            label={t("personaJuridica.razonSocial")}
                            value={value?.razonSocial}
                            onChange={(event) => {
                              event.preventDefault();
                              setProperty("razonSocial", event.target.value);
                            }}
                            isInvalid={isInvalid("tratador.razonSocial", form)}
                            error={t(form.errors.tratador?.razonSocial)}
                            disabled={disabled}
                          />
                        </Col>
                      </Row>
                    </Grid>
                  )}
                </ObjectField>
              </Col>
            </Row>

            <Row style={{ display: "flex", flexWrap: "wrap" }}>
              <Col lg={6}>
                <Pagination
                  sm
                  page={page}
                  pages={pages}
                  onChange={(event) => select(event.target.value)}
                />
              </Col>
              <Col lg={6}>
                <span
                  style={{
                    float: "right",
                    alignContent: "center",
                  }}
                >
                  {page !== -1 && (
                    <Button
                      sm
                      variant="success"
                      value={t("tratamientoExternoForm.nuevo")}
                      onClick={(event) => {
                        event.preventDefault();
                        select(-1);
                      }}
                      disabled={disabled}
                    />
                  )}
                  {page !== -1 && (
                    <Button
                      sm
                      variant="danger"
                      value={t("tratamientoExternoForm.eliminar")}
                      onClick={(event) => {
                        event.preventDefault();
                        remove(page);
                      }}
                      disabled={disabled}
                    />
                  )}
                  <Button
                    sm
                    variant="primary"
                    value={t("tratamientoExternoForm.guardar")}
                    onClick={(event) => {
                      event.preventDefault();
                      form.submitForm();
                    }}
                    disabled={disabled}
                  />
                  {page === -1 && pages > 0 && (
                    <Button
                      sm
                      variant="default"
                      value={t("tratamientoExternoForm.cancelar")}
                      onClick={(event) => {
                        event.preventDefault();
                        select(0);
                      }}
                      disabled={disabled}
                    />
                  )}
                </span>
              </Col>
            </Row>
          </Grid>
        )}
      </Formik>
    </>
  );
}
